import appConstants from '@/constants/constants'

export default {
  wageData: [],
  medicalStaff: [],
  revenueTypeOptions: [
    {
      value: appConstants.wage.revenueType.CASH_REGISTER_REVENUE_PERCENT,
      text: appConstants.wage.revenueType.CASH_REGISTER_REVENUE_PERCENT_LABEL,
    },
    {
      value: appConstants.wage.revenueType.SERVICE_REVENUE,
      text: appConstants.wage.revenueType.SERVICE_REVENUE_LABEL,
    },
  ],
}
